/*
 * Filter stream
 * Old C&L
 */

$(document).ready(function () {
    // get the filter-list from local storage:
    var filterList = JSON.parse(localStorage.getItem('filterlist'));
   
    // counter is used to check if there are any visible results based on active filters
    var counter = 0;
   
    // empty all the checkboxes to avoid confusion:
    $('.filter-js input:checkbox').removeAttr('checked');

    // Check if the filter exists and is bigger than 0
    if(filterList != null && filterList.length > 0 ){
        counter = 0;
    $('.filter-row').hide();
    $('#clear-filter').show();
        // loop through the list - check the boxes and show the rows that are checked
        $(filterList).each(function (i){
            // Check the boxes
            $(":checkbox[value=" + filterList[i]['filterID'] + "]").prop("checked","true");
            // Show the boxes that are in the list.
            $('.filter-row').each(function () {
                if($(this).data("filter-id") == filterList[i]['filterID']){
                    $(this).fadeIn(500);
                    counter += 1;
                }
            });
        });
        showOrHideFilterMessage(counter);
    } else{
        // If the local storage list is empty -> Show everything
        $('.filter-row').fadeIn(500);
        $('#clear-filter').hide();
    }

    // when the apply filter button is clicked
    $('#apply-filter').on('click', function () {
        $('.filter-row').hide();
        // Find number of checked boxes:
        var checkedBoxes = $('.filter-js').find('input:checked').length;
        // empty the filter list
        filterList = [];
        // Check if there is one or more checked boxes:
        if(checkedBoxes > 0){
            counter = 0; 
            // Loop through all the boxes:
            $('.filter-js').find('input:checked').each(function () {
                // Grab the name of the current stream name from the value
                var filterID = $(this).val();
                var filterName = $(this).data('filter-name');
                filterList.push({filterID:filterID,filterName:filterName});
                localStorage.setItem("filterlist",JSON.stringify(filterList));
               
                // Loop through filter rows and show the row if it matches the current filter name:
                $('.filter-row').each(function () {
                    if($(this).data("filter-id") == filterID){
                        $(this).fadeIn(500);
                        counter += 1;
                    }
                });
               
            });

            showOrHideFilterMessage(counter);

            $('#clear-filter').fadeIn(500);
       
        // If there are no boxes checked -> show all
        } else{
            localStorage.setItem("filterlist",JSON.stringify(filterList));
            $('.filter-row').fadeIn(500);
            $('#clear-filter').hide();
        }
    });

    // when the CLEAR filter button is clicked
    $('#clear-filter').on('click', function () {
        // show all .filter-row
        $('.filter-row').fadeIn(500);
        showOrHideFilterMessage(1);
       
        // uncheck all the boxes
        $(".filter-js").find("input[type='checkbox']").each(function(){
            $(this).prop("checked",false);
        })
       
        // Set local storage to empty
        filterList = [];
        localStorage.setItem("filterlist",JSON.stringify(filterList));
       
        // hide the button
        $(this).hide();
    });

    // helper function for showing or hiding the filter message
    function showOrHideFilterMessage(counter){
        if(counter == 0){
            $('.filter-message').fadeIn(500);              
        } else{
            $('.filter-message').fadeOut(500);
        }
    }
});